import React from 'react';
import {
    Box,
    Typography,
    TextField,
    Stack,
    InputAdornment,
    CircularProgress,
    IconButton,
    useTheme
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const BankInformationForm = ({
    formData,
    errors,
    isIfscLoading,
    onChange
}) => {
    const theme = useTheme();

    return (
        <Box>
            <Typography variant="subtitle2" sx={{
                mb: 2,
                color: theme.palette.text.secondary,
                fontWeight: 600
            }}>
                Bank Information
            </Typography>
            <Stack spacing={2.5}>
                <TextField
                    fullWidth
                    label="IFSC Code"
                    name="ifsc"
                    value={formData.ifsc}
                    onChange={onChange}
                    error={Boolean(errors.ifsc)}
                    helperText={errors.ifsc || "Enter your bank's IFSC code to auto-fill bank details"}
                    placeholder="Enter IFSC code"
                    InputProps={{
                        sx: { borderRadius: 2 },
                        endAdornment: (
                            <InputAdornment position="end">
                                {isIfscLoading ? (
                                    <CircularProgress size={20} />
                                ) : (
                                    <IconButton
                                        edge="end"
                                        size="small"
                                        onClick={() => window.open('https://www.rbi.org.in/Scripts/IFSCMICRDetails.aspx', '_blank')}
                                    >
                                        <InfoOutlinedIcon sx={{ fontSize: 20, color: theme.palette.text.secondary }} />
                                    </IconButton>
                                )}
                            </InputAdornment>
                        )
                    }}
                />

                <TextField
                    fullWidth
                    label="Bank Name"
                    name="bank_name"
                    value={formData.bank_name}
                    onChange={onChange}
                    error={Boolean(errors.bank_name)}
                    helperText={errors.bank_name}
                    placeholder="Enter your bank name or use IFSC code above"
                    InputProps={{
                        sx: { borderRadius: 2 },
                        readOnly: Boolean(formData.ifsc && formData.bank_name),
                    }}
                />

                <TextField
                    fullWidth
                    label="Bank Account Number"
                    name="bank_account_number"
                    value={formData.bank_account_number}
                    onChange={onChange}
                    error={Boolean(errors.bank_account_number)}
                    helperText={errors.bank_account_number}
                    placeholder="Enter your account number"
                    InputProps={{
                        sx: { borderRadius: 2 }
                    }}
                />
            </Stack>
        </Box>
    );
};

export default BankInformationForm;
